@if (pending) {
  <mat-progress-bar mode="indeterminate" class="absolute-top"></mat-progress-bar>
}
<h2 mat-dialog-title>{{'CURRENT_OFFERS.PAYMENT.ADD.' + (data.replace ? 'TITLE_REPLACE' : 'TITLE') | translate}}</h2>
<mat-dialog-content>
  <p>{{'CURRENT_OFFERS.PAYMENT.ADD.MESSAGE' | translate}}</p>
  @if (this.error) {
    <p class="error">
      {{'CURRENT_OFFERS.PAYMENT.ADD.ERROR.' + (error.code ? error.code : 'DEFAULT') | translate}}
    </p>
  }
  <div class="input-ctn">
    <label>{{'CURRENT_OFFERS.PAYMENT.ADD.CARD' | translate}}</label>
    <div id="card-element" class="field"></div>
  </div>
  <div class="payment-logos">
    <ul>
      <li><img alt="cb" src="assets/images/cb.png"></li>
      <li><img alt="visa" src="assets/images/visa.png"></li>
      <li><img alt="mastercard" src="assets/images/mastercard.png"></li>
      <li><img alt="american express" src="assets/images/americanexpress.png"></li>
    </ul>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="btn-uppercase align-right">
  <button mat-button color="primary" [disabled]="pending" [mat-dialog-close]="null">
    {{'COMMON.BUTTONS.CANCEL' | translate}}
  </button>
  <button mat-button color="primary" [disabled]="pending" (click)="setPaymentSource()">
    {{'COMMON.BUTTONS.SUBMIT' | translate}}
  </button>
</mat-dialog-actions>
